<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";

/**
 * Form elements component
*/

export default {
    page: {
        title: "Procedimiento de auditoría",
        meta: [{ name: "procedimiento-auditoria", content: appConfig.description }],
    },
    components: {
        Layout,
        PageHeader,
        Style,
    },
    data() {
        return {
            title: "",
            items: [
                {
                    text: "Base de conocimiento",
                    href: "/forms/general",
                },

                {
                    text: "Procedimiento de auditoría",
                    active: true,
                },
            ],
            loading: true,
            classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
            companies_id: this.$store.getters["company/getCompany"].id || null,
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        /**
         * Scrollspy
         */
        scrollIntoView(evt) {
            evt.preventDefault();
            const href = evt.target.getAttribute("href");
            const el = href ? document.querySelector(href) : null;
            if (el) {
                this.$refs.content.scrollTop = el.offsetTop;
            }
        },
    },
};

</script>

<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="row animated animatedFadeInUp fadeInUp">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-12 text-right m-b-0 mb-2">
                                <button @click="goBack" id="goback" class="btn btn-secondary m-l-5 ml-1">
                                    <i class="fas fa-arrow-left"></i>
                                </button>
                                <b-tooltip target="goback" placement="left">Volver</b-tooltip>
                            </div>
                        </div>

                        <br>

                        <b-row>
                            <p>
                                Las auditorias son pun proceso para determinar la implementación, mantenimiento, mejora
                                del Sistema de Gestión y el grado
                                de cumplimiento de los requisitos del SG SST, realizada por un equipo auditor. Por medio
                                de la auditoria se evaluan los
                                criterios de la auditoria, se recogen evidencias y se generan hallazgos.
                            </p>
                        </b-row>

                        <b-row>
                            <p>
                                En el Decreto 1072 de 2015 se establece que el empleador debe realizar una auditoría
                                anual, la cual será planificada
                                con la participación del Comité Paritario o Vigía de Seguridad y Salud en el Trabajo. Si
                                la auditoría se realiza
                                con personal interno de la entidad, debe ser independiente a la actividad, área o
                                proceso objeto de verificación.
                            </p>
                        </b-row>

                        <b-row>
                            <p>
                                <strong>Para cumplir con dicho requisito, la empresa debe elaborar</strong> El programa
                                de auditoría debe comprender entre otros,
                                la definición de la idoneidad de la persona que sea auditora, el alcance de la
                                auditoría, la periodicidad, la metodología
                                y la presentación de informes, y debe tomarse en consideración resultados de auditorías
                                previas. La selección del personal
                                auditor no implicará necesariamente aumento en la planta de cargos existente. Los
                                auditores no deben auditar su propio trabajo.
                            </p>
                        </b-row>

                        <b-row>
                            <p>
                                Los resultados de la auditoría deben ser comunicados a los responsables de adelantar las
                                medidas preventivas, correctivas o de mejora en la empresa.
                            </p>
                        </b-row>

                        <b-row>
                            <p>
                                El proceso de auditoría interna del SG SST deberá abarcar entre otros lo siguiente:
                            </p>
                        </b-row>

                        <b-row>
                            <ol>
                                <li>El cumplimiento de la política de seguridad y salud en el trabajo.</li>
                                <li>El resultado de los indicadores de estructura, proceso y resultado.</li>
                                <li>La participación de los trabajadores.</li>
                                <li>El desarrollo de la responsabilidad y la obligación de rendir cuentas.</li>
                                <li>El mecanismo de comunicación de los contenidos del Sistema de Gestión de la
                                    Seguridad y
                                    Salud en el Trabajo (SG-SST), a los trabajadores.</li>
                                <li>La planificación, desarrollo y aplicación del Sistema de Gestión de la Seguridad y
                                    Salud en el Trabajo (SG-SST).</li>
                                <li>La gestión del cambio.</li>
                                <li>La consideración de la seguridad y salud en el trabajo en las nuevas adquisiciones.
                                </li>
                                <li>El alcance y aplicación del Sistema de Gestión de la Seguridad y Salud en el Trabajo
                                    (SG-SST) frente a los proveedores y contratistas.</li>
                                <li>La supervisión y medición de los resultados.</li>
                                <li>El proceso de investigación de incidentes, accidentes de trabajo y enfermedades
                                    laborales, y su efecto sobre el
                                    mejoramiento de la seguridad y salud en el trabajo en la empresa.</li>
                                <li>El desarrollo del proceso de auditoría.</li>
                                <li>La evaluación por parte de la alta dirección.</li>
                            </ol>
                        </b-row>

                        <br>

                        <b-row>
                            <strong>PROCEDIMIENTO PARA LA REALIZACIÓN DE LA AUDITORIA</strong>
                        </b-row>

                        <b-row>
                            <ol>
                                <li><strong>OBJETO</strong></li>
                                <p>
                                    Este procedimiento describe las actividades a realizar, para llevar a cabo las
                                    auditorias
                                    internas en la empresa y verificar el cumplimiento y eficacia del Sistema de Gestión
                                    de seguridad y salud en el trabajo.
                                </p>
                                <li><strong>ALCANCE</strong></li>
                                <p>
                                    Este procedimiento aplica para todos los procesos y áreas de la empresa.
                                </p>
                                <li><strong>DEFINICIONES</strong></li>
                                <ul>
                                    <li><strong>Auditoria:</strong></li>
                                    <p>
                                        Proceso sistemático, independiente y documentado para tener evidencias objetivas
                                        y evaluarlas
                                        de manera objetiva con el fin de determinar el grado en que se cumplen los
                                        criterios de auditoria.
                                    </p>
                                    <li><strong>Criterios de auditoría:</strong></li>
                                    <p>
                                        Conjunto de políticas, procedimientos o requisitos usados como referencia frente
                                        a la cual
                                        se compara la evidencia objetiva.
                                    </p>
                                    <li><strong>Hallazgos de auditoría:</strong></li>
                                    <p>
                                        Resultados de la evaluación de la evidencia de la auditoría recopilada frente a
                                        los criterios de la auditoría.
                                    </p>
                                    <li><strong>Auditor principal:</strong></li>
                                    <p>
                                        Auditor responsable de coordinar todas las actividades relacionadas con las
                                        auditorias,
                                        como la elaboración del programa de auditoria interna, seguimiento a la entrega
                                        oportuna
                                        de informes de auditoria, entre otras.
                                    </p>
                                    <li><strong>Oportunidad de Mejora:</strong></li>
                                    <p>
                                        Es levantada cuando la falta de cumplimiento de un requisito no puede ser
                                        incorporada como No
                                        Conformidad, por no disponerse de suficientes evidencias que la sustenten. Son
                                        también
                                        denominadas Acciones por seguir, que se tienen en cuenta para ser revisadas en
                                        las siguientes auditorías internas.
                                    </p>
                                    <li><strong>Equipo auditor:</strong></li>
                                    <p>
                                        Una o más personas que llevan.
                                    </p>
                                </ul>
                                <p>
                                    Los demás términos relacionados con auditorias internas, están definidos en la Norma
                                    ISO 9000:2015 “Fundamentos y vocabulario”.
                                </p>
                                <li><strong>OBJETO</strong></li>
                                <ul>
                                    <p><strong>Competencias de los auditores:</strong></p>
                                    <div class="container">
                                        <div class="row">
                                            <div class="col">
                                                <li><strong>Educación</strong></li>
                                            </div>
                                            <div class="col">
                                                <p>Profesional</p>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <li><strong>Formación</strong></li>
                                            </div>
                                            <div class="col">
                                                <p>Profesional</p>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <li><strong>Experiencia</strong></li>
                                            </div>
                                            <div class="col">
                                                <p>Profesional</p>
                                            </div>
                                        </div>
                                    </div>
                                </ul>
                            </ol>
                        </b-row>

                        <b-row>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col"><strong>#</strong></th>
                                        <th scope="col"><strong>ACTIVIDAD</strong></th>
                                        <th scope="col"><strong>RESPONSABLE</strong></th>
                                        <th scope="col"><strong>DOCUMENTOS Y REGISTROS</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td>
                                            <p>
                                                Seleccionar el equipo auditor para la auditoría interna a realizar.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Responsable del SG SST / Gerencia.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Registros de la competencia de los auditores.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">2</th>
                                        <td>
                                            <p>
                                                Elaborar un Programa de auditoría interna para la Empresa (mínimo una
                                                vez al año y aprobado por el Gerente)
                                                y teniendo en cuenta los resultados de auditoría interna y externa
                                                anteriores, no - conformidades
                                                detectadas por fuera de auditoría y deficiencias en la implementación
                                                del SG de SST.
                                                Se envía este programa al equipo auditor y los auditados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Responsable del SG SST.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Programa de auditorías Plan de trabajo anual del SG SST.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">3</th>
                                        <td>
                                            <p>
                                                Elaborar un plan de auditoría interna y enviarlo al auditado para su
                                                preparación.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Auditores asignados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Plan de auditoría interna.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4</th>
                                        <td>
                                            <p>
                                                Preparar listas de verificación (o reporte de auditoría), de acuerdo con
                                                el propósito y alcance de la auditoria.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Auditores asignados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Lista de verificación.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4.1</th>
                                        <td>
                                            <p>
                                                Ejecutar la auditoría interna, teniendo en cuenta los siguientes
                                                aspectos:
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Auditores asignados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Lista de verificación Informe de auditoría.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4.1.1</th>
                                        <td>
                                            <p>
                                                Reunión de apertura: Explicar al auditado, el objetivo, el alcance y la
                                                metodología
                                                para realizar la auditoría interna, además, los criterios para calificar
                                                la no - conformidad hallada.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Auditores asignados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Acta de reunión.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4.1.2</th>
                                        <td>
                                            <p>
                                                Ejecución de la auditoria: Realizar entrevista, observación directa de
                                                actividades,
                                                procedimientos, registros o cualquier evidencia objetiva y reportarlas
                                                en el registro respectivo.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Auditores asignados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Lista de verificación.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">4.1.3</th>
                                        <td>
                                            <p>
                                                Reunión de cierre: Presentar a los auditados los resultados de la
                                                auditoría interna y
                                                el estado de la implementación del SG.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Auditores asignados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Acta de reunión.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">5</th>
                                        <td>
                                            <p>
                                                Entregar al auditado, el informe de auditoría y el reporte de las no -
                                                conformidades encontradas,
                                                para que éste, determine e inicie, la acción correctiva necesaria, para
                                                corregir la no - conformidad,
                                                o la causa de la misma.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Auditores asignados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                nforme de auditoría.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">6</th>
                                        <td>
                                            <p>
                                                Acciones correctivas y preventivas: Tomar las acciones correctivas y/o
                                                preventivas
                                                de los hallazgos generados en la auditoría, conforme al procedimiento
                                                de acciones correctivas y preventivas.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Responsable del SG SST Auditados.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Acciones correctivas y preventivas
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">7</th>
                                        <td>
                                            <p>
                                                Anualmente, se realiza la evaluación del desempeño del equipo auditor,
                                                como una manera de establecer la competencia de los auditores internos.
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Responsable del SG SS
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                Evaluación del desempeño de los auditores internos.
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-row>

                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>